module.exports = __webpack_public_path__ + "static/media/кардио - дорожка беговая.83a19f48.jpg";